import React, {Component} from 'react';
import Places from '../../data/places.data'
import { AppDataParam } from '../../utils/constUtils'
import compose from '../../utils/compose'
import withNofeshService  from '../../hoc/withNofeshService.hoc';

class SearchFieldPlace extends Component {


    unsubscribe = null;
    state = { 
        open:false,        
        places : {
            checkedEilat :false,
            checkedDeadSea: false,
            checkedKineret : false, 
            checkedMerchaz : false, 
            checkedJerusalem : false,
            checkedDarom:false
        },
        searchFieldOK : false,
        places_placeholder: ''
    }



    componentDidMount = () => {   

        const { search_param_places }= this.props.currentSearchObj;
        this.setState({ places: search_param_places});

        let places = this.getPlacesText( search_param_places );        
        this.setState({places_placeholder:places});
    }



    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (prevProps.shouldClose === false && this.props.shouldClose === true)
        {
            this.setState({open:false}); 
        }

        return null;
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        /*
        const { currentSearchObj }= this.props;
        if (prevProps.currentSearchObj !== currentSearchObj) {
            if (currentSearchObj) {
                let placesStr = this.getPlacesText();        
                this.setState({places_placeholder:placesStr});
            }
        }
        */
    }

    getPlacesText = (places) =>  { 
        let s = '';
        let addComa = false;
               

        if (places.checkedEilat) {
            s = Places.Eilat();
            addComa = true;
        }
        if (places.checkedDeadSea) {
            if (addComa) s = s + ',';
            s = s + Places.DeadSea();
            addComa = true;
        }
        if (places.checkedLowerGalilee) {
            if (addComa) s = s + ',';
            s = s + Places.LowerGalilee();
            addComa = true;
        }
        if (places.checkedUpperGalilee) {
            if (addComa) s = s + ',';
            s = s + Places.UpperGalilee();
            addComa = true;
        }

        if (places.checkedWestGalilee) {
            if (addComa) s = s + ',';
            s = s + Places.WestGalilee();
            addComa = true;
        }


        if (places.checkedKineret) {
            if (addComa) s = s + ',';
            s = s + Places.Kineret();
            addComa = true;
        }

        if (places.checkedMerchaz) {
            if (addComa) s = s + ',';
            s = s + Places.Merchaz();
            addComa = true;
        }

        if (places.checkedJerusalem) {
            if (addComa) s = s + ',';
            s = s + Places.Jerusalem();
            addComa = true;
        }

        if (places.checkedHasharon) {
            if (addComa) s = s + ',';
            s = s + Places.Hasharon();
            addComa = true;
        }

        if (places.checkedDarom) {
            if (addComa) s = s + ',';
            s = s + Places.Darom();
            addComa = true;
        }

        if ( s.length > 28) {s = s.substring(0,27) + ' ...';}
        return s;
        
    }
    

    setOK = () =>  { 

        let placesStr = this.getPlacesText(this.state.places);        
        this.setState({places_placeholder:placesStr});
        this.setState({searchFieldOK:true});        
        this.setState({open:false});   
               
        const data = { search_param_places : this.state.places };        
        this.props.setCurrentAppData(data,AppDataParam.set_app_data);
    }


    resetClear = () =>  { 
        this.setState({searchFieldOK:false});    
        this.setState({places_placeholder:''});  
        this.setState(prevState => {            
            let places = { ...prevState.places };
            places.checkedEilat = false;
            places.checkedDeadSea = false;
            places.checkedKineret = false;
            places.checkedMerchaz = false;
            places.checkedJerusalem = false;
            places.checkedDarom = false;

            return { places };
          })        


          const data = { search_param_places : this.state.places }; 
          this.props.setCurrentAppData(data, AppDataParam.reset_search_param_places);


    }
    
    toggleOpenClose = () =>  {
        const open = !this.state.open;    
        this.setState({open:open});         
        let data = {};
        data.SearchFieldPlaceOpened = open;
        this.props.updateOpenSearchFieldFn(data);
    }

    toggleEilat = ()  => {        
        const b = this.state.places.checkedEilat;        
        this.setState(prevState => {            
            let places = { ...prevState.places };
            places.checkedEilat = !b;
            return { places };
          })        
    }

    toggleDeadSea = ()  => {        
        const b = this.state.places.checkedDeadSea;        
        this.setState(prevState => {            
            let places = { ...prevState.places };
            places.checkedDeadSea = !b;
            return { places };
          })       
    }



    toggleKineret = ()  => {        
        const b = this.state.places.checkedKineret;        
        this.setState(prevState => {            
            let places = { ...prevState.places };
            places.checkedKineret = !b;
            return { places };
          })        
    }

    toggleMerchaz = ()  => {        
        const b = this.state.places.checkedMerchaz;          
        this.setState(prevState => {            
            let places = { ...prevState.places };
            places.checkedMerchaz = !b;
            return { places };
          })        
    }

    toggleJerusalem = ()  => {        
        const b = this.state.places.checkedJerusalem;
        this.setState(prevState => {            
            let places = { ...prevState.places };
            places.checkedJerusalem = !b;
            return { places };
          })        
    }

    toggleDarom = ()  => {        
        const b = this.state.places.checkedDarom;        
        this.setState(prevState => {            
            let places = { ...prevState.places };
            places.checkedDarom = !b;
            return { places };
          })        
    }

    

  render() { 
    let is_open = false;
    if (this.props.shouldClose) { is_open = false;   }        
    is_open = this.state.open;

    return (    

            <React.Fragment>
                <div  className="hp_search_field_container hp_search_field_marginRight38 "
                    >

                    
                    {(this.state.places_placeholder !== '')?
                        <span className="hp_search_field_dropDown_inner_placeBox_title_small">
                        לאן נוסעים ?</span>  : null}

                    
                        <div className="hp_search_field_titleTest_new pointer" onClick={this.toggleOpenClose}>

                         {(this.state.places_placeholder == '')?
                            <span> לאן נוסעים ? </span>
                        : 
                        <span>{ this.state.places_placeholder}</span>
                        }

                        <span className="open_arrow_new pointer" 
                            onClick={this.toggleOpenClose}></span>
                        </div>
                                
                    { (is_open) ?
                        <div className="hp_search_field_dropDown_containerPlaces" >
                            <div className="close_arrow pointer" onClick={this.toggleOpenClose}></div>
                            <div className="hp_search_field_dropDown_innerTitle">בחירת איזור</div>
                            <div className="hp_search_field_dropDown_inner_container">

                                <div onClick={this.toggleEilat}
                                    className={
                                        this.state.places.checkedEilat
                                        ? 'hp_search_field_dropDown_inner_placeBox placeBox_selected' 
                                        : 'hp_search_field_dropDown_inner_placeBox placeBox_unselected' }>
                                    <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                                        { (this.state.places.checkedEilat) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                    </div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_title">אילת</div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_picWrapper">
                                        <img  className="unselectable" src={"./images/site/components/eilat.png"} alt="אילת" />
                                    </div>
                                </div>


                                <div  onClick={this.toggleDeadSea}
                                    className={
                                        this.state.places.checkedDeadSea
                                        ? 'hp_search_field_dropDown_inner_placeBox placeBox_selected' 
                                        : 'hp_search_field_dropDown_inner_placeBox placeBox_unselected' }>
                                    <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                                        { (this.state.places.checkedDeadSea) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                    </div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_title">ים המלח</div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_picWrapper">
                                        <img className="unselectable" src={"./images/site/components/dead-sea.png"} alt="ים המלח" />
                                    </div>
                                </div>


                                <div  onClick={this.toggleKineret}
                                    className={
                                        this.state.places.checkedKineret
                                        ? 'hp_search_field_dropDown_inner_placeBox placeBox_selected' 
                                        : 'hp_search_field_dropDown_inner_placeBox placeBox_unselected' }>
                                    <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                                        { (this.state.places.checkedKineret) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                    </div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_title">כנרת והצפון</div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_picWrapper">
                                        <img className="unselectable" src={"./images/site/components/kineret.png"} alt=""/>
                                    </div>
                                </div>


                                <div  onClick={this.toggleMerchaz}
                                    className={
                                        this.state.places.checkedMerchaz
                                        ? 'hp_search_field_dropDown_inner_placeBox placeBox_selected' 
                                        : 'hp_search_field_dropDown_inner_placeBox placeBox_unselected' }>
                                    <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                                        { (this.state.places.checkedMerchaz) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                    </div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_title"> מרכז והשרון</div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_picWrapper">
                                        <img className="unselectable" src={"./images/site/components/center.png"} alt=""/>
                                    </div>
                                </div>


                                <div  onClick={this.toggleJerusalem}
                                    className={
                                        this.state.places.checkedJerusalem
                                        ? 'hp_search_field_dropDown_inner_placeBox placeBox_selected' 
                                        : 'hp_search_field_dropDown_inner_placeBox placeBox_unselected' }>
                                    <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                                        { (this.state.places.checkedJerusalem) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                    </div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_title">ירושלים</div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_picWrapper">
                                        <img className="unselectable" src={"./images/site/components/jerusalem.png"} alt=""/>
                                    </div>
                                </div>


                                <div  onClick={this.toggleDarom}
                                    className={
                                        this.state.places.checkedDarom
                                        ? 'hp_search_field_dropDown_inner_placeBox placeBox_selected' 
                                        : 'hp_search_field_dropDown_inner_placeBox placeBox_unselected' }>
                                    <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                                        { (this.state.places.checkedDarom) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                    </div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_title">אזור הדרום</div>
                                    <div className="hp_search_field_dropDown_inner_placeBox_picWrapper">
                                        <img className="unselectable" src={"./images/site/components/hasharon.png"} alt=""/>
                                    </div>
                                </div>                                
                            </div>


                            <div className="hp_search_field_dropDown_inner_button_ok"
                                onClick={ () => this.setOK()}>
                                <div className="title">
                                    אישור
                                </div>
                            </div>

                            <div className="hp_search_field_dropDown_inner_button_clear"
                                onClick={this.resetClear}>
                                נקה
                            </div>

                        </div>    
                        : null
                    }
                </div>                
            </React.Fragment>          
    )

  }
}


export default compose(
    withNofeshService()
  )(SearchFieldPlace);